import $ from "jquery";

export default function ElementToggler() {
}

function attachTogglerEvent() {
  $('.js-show-element-button').off("click").on("click", function () {
    var targetId = $(this).data('target-id');
    var target = $('#' + targetId);
    target.slideToggle();
  });
}

ElementToggler.prototype.init = function () {
  $(document).ready(function () {
    attachTogglerEvent();
  });

  $(document).ajaxComplete(function () {
    attachTogglerEvent();
  });
};

